// Add polyfill for `fetch`
require('whatwg-fetch');
// Add polyfill for `Promise`
require('promise-polyfill');

var cdb = require('./cartodb.js');

module.exports = cdb;



//////////////////
// WEBPACK FOOTER
// ./~/cartodb.js/src/index.js
// module id = 6
// module chunks = 6